export const colors = {
  red0: '#7f1919',
  red1: '#941d1d',
  red2: '#aa2222',
  red3: '#bf2626',
  red4: '#d42a2a',
  red5: '#ea2f2f',
  red6: '#ff3333',
  red7: '#ff5c5c',
  red8: '#ff8585',
  red9: '#ffadad',
  red10: '#ffd6d6',
  red11: '#ffebeb',

  gray0: '#333030',
  gray1: '#3e3e39',
  gray2: '#484342',
  gray3: '#534d4c',
  gray4: '#5d5655',
  gray5: '#68605e',
  gray6: '#736967',
  gray7: '#878786',
  gray8: '#aba5a4',
  gray9: '#c7c3c2',
  gray10: '#e3e1e1',
  gray11: '#f1f0f0',
  gray12: '#f8f8f7',

  green0: '#003321',
  green1: '#004930',
  green2: '#005f3f',
  green3: '#00754e',
  green4: '#008a5d',
  green5: '#00a16c',
  green6: '#00b87a',
  green7: '#33c695',
  green8: '#66d4af',
  green9: '#99e2ca',
  green10: '#ccf1e4',
  green11: '#e5f8f2',
  green12: '#f2fbf8',

  orange0: '#98402b',
  orange1: '#a94830',
  orange2: '#ba5034',
  orange3: '#cb5839',
  orange4: '#dc5f3e',
  orange5: '#ed6743',
  orange6: '#ff6f47',
  orange7: '#ff8c6c',
  orange8: '#ffa991',
  orange9: '#ffc5b6',
  orange10: '#ffe2da',
  orange11: '#fff1ed',
  orange12: '#fff8f6',

  yellow0: '#98761f',
  yellow1: '#a88222',
  yellow2: '#b88f25',
  yellow3: '#c89c28',
  yellow4: '#d9a92c',
  yellow5: '#e9b62f',
  yellow6: '#fac532',
  yellow7: '#fbd05b',
  yellow8: '#fcdc84',
  yellow9: '#fde8ad',
  yellow10: '#fef3d6',
  yellow11: '#fef9ea',
  yellow12: '#fffcf5',

  //text-colors
  highEmphasisText: '#2e3b4e',
  mediumEmphasisTextLight: '#626e89',
  lowEmphasisTextPlaceholder: '#acb2c3',
  white: '#ffffff',
  separatorColor: '#e3e9eb',
  bgGray: '#FAFAFA',
  border: '#dfe7ef',
};

export enum Colors {
  red0 = '#7f1919',
  red1 = '#941d1d',
  red2 = '#aa2222',
  red3 = '#bf2626',
  red4 = '#d42a2a',
  red5 = '#ea2f2f',
  red6 = '#ff3333',
  red7 = '#ff5c5c',
  red8 = '#ff8585',
  red9 = '#ffadad',
  red10 = '#ffd6d6',
  red11 = '#ffebeb',

  gray0 = '#333030',
  gray1 = '#3e3e39',
  gray2 = '#484342',
  gray3 = '#534d4c',
  gray4 = '#5d5655',
  gray5 = '#68605e',
  gray6 = '#736967',
  gray7 = '#878786',
  gray8 = '#aba5a4',
  gray9 = '#c7c3c2',
  gray10 = '#e3e1e1',
  gray11 = '#f1f0f0',

  green0 = '#003321',
  green1 = '#004930',
  green2 = '#005f3f',
  green3 = '#00754e',
  green4 = '#008a5d',
  green5 = '#00a16c',
  green6 = '#00b87a',
  green7 = '#33c695',
  green8 = '#66d4af',
  green9 = '#99e2ca',
  green10 = '#ccf1e4',
  green11 = '#e5f8f2',
  green12 = '#f2fbf8',

  orange0 = '#98402b',
  orange1 = '#a94830',
  orange2 = '#ba5034',
  orange3 = '#cb5839',
  orange4 = '#dc5f3e',
  orange5 = '#ed6743',
  orange6 = '#ff6f47',
  orange7 = '#ff8c6c',
  orange8 = '#ffa991',
  orange9 = '#ffc5b6',
  orange10 = '#ffe2da',
  orange11 = '#fff1ed',
  orange12 = '#fff8f6',

  yellow0 = '#98761f',
  yellow1 = '#a88222',
  yellow2 = '#b88f25',
  yellow3 = '#c89c28',
  yellow4 = '#d9a92c',
  yellow5 = '#e9b62f',
  yellow6 = '#fac532',
  yellow7 = '#fbd05b',
  yellow8 = '#fcdc84',
  yellow9 = '#fde8ad',
  yellow10 = '#fef3d6',
  yellow11 = '#fef9ea',
  yellow12 = '#fffcf5',

  highEmphasisText = '#2e3b4e',
  mediumEmphasisTextLight = '#626e89',
  lowEmphasisTextPlaceholder = '#acb2c3',
  separatorColor = '#e3e9eb',
  bgGray = '#FAFAFA',
  border = '#dfe7ef',
}
